module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm._l((_vm.icons), function(type, i) {
    return [_c('vCol', {
      attrs: {
        "xlg": 3,
        "lg": 4,
        "md": 6,
        "sm": 8
      }
    }, [_c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (("<Icon name=\"" + type + "\"></Icon>")),
        expression: "`<Icon name=\"${type}\"></Icon>`",
        arg: "copy"
      }],
      staticClass: "icon-item",
      on: {
        "click": function($event) {
          _vm.clickHandle(i)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "size": 26,
        "name": type
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-name",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          void 0
        }
      }
    }, [_vm._v(_vm._s(type))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.index === i) ? _c('div', {
      staticClass: "copy_success"
    }, [_vm._v("\n            Copy Success!\n          ")]) : _vm._e()])], 1)])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-316888ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/IconList.vue
// module id = 631
// module chunks = 0